import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("iframe", {
  id: "bookingFormPreview",
  src: "",
  width: "100%",
  height: "1000px",
  allow: "autoplay"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_collapse_comp = _resolveComponent("collapse-comp")!

  return (_openBlock(), _createBlock(_component_collapse_comp, {
    StartMinimized: true,
    Title: 'Click to View Booking Document'
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}